import React from 'react';

import {ACTIONS} from './constants';
import type {State} from './reducer';

import {AttributePermission, PartialAttributePermission} from '../types';

export type Action =
	| {type: typeof ACTIONS.RESET}
	| {type: typeof ACTIONS.UPDATE; data: State['data']}
	| {type: typeof ACTIONS.SET_LOADING; loading: State['loading']}
	| {
			type: typeof ACTIONS.DELETE_PERMISSION;
			groupId: AttributePermission['groupId'];
	  }
	| {
			type: typeof ACTIONS.ADD_PERMISSION;
			permission: PartialAttributePermission;
	  }
	| {type: typeof ACTIONS.SET_SAVING; saving: State['saving']}
	| {type: typeof ACTIONS.SET_TEMPLATE_ID; templateId: State['templateId']}
	| {type: typeof ACTIONS.UPDATE_PERMISSION; permission: AttributePermission};

export const Actions = (dispatch: React.Dispatch<Action>) => ({
	addPermission: (permission: PartialAttributePermission) =>
		dispatch({type: ACTIONS.ADD_PERMISSION, permission}),

	deletePermission: (groupId: AttributePermission['groupId']) =>
		dispatch({type: ACTIONS.DELETE_PERMISSION, groupId}),

	resetPermissions: () => dispatch({type: ACTIONS.RESET}),

	updatePermission: (permission: AttributePermission) =>
		dispatch({type: ACTIONS.UPDATE_PERMISSION, permission}),
});

export default Actions;
